module.exports = __webpack_public_path__ + "img/logo.71c059f2.gif";